module.exports = __webpack_public_path__ + "img/logo-facebook.2169f2ed.svg";